export const env = {
  NODE_ENV: process.env.NODE_ENV,
  TRACKJS_TOKEN: process.env.GATSBY_APP_TRACKJS_TOKEN,
  // If set to true, will output additional GA feedback to the console
  GA_DEBUG: process.env.GATSBY_GA_DEBUG === 'true',
  GIPHY_API_KEY: process.env.GATSBY_GIPHY_API_KEY,
  GIPHY_LOGIN_URL: process.env.GATSBY_GIPHY_LOGIN_URL ?? 'https://giphy.com/login',
  GIPHY_VALIDATE_TOKEN_URL:
    process.env.GATSBY_GIPHY_VALIDATE_TOKEN_URL ??
    'https://x.giphy.com/v1/internal/oauth2/token/validate',
} as const
